module.exports = __webpack_public_path__ + "img/x_black.c0485431.svg";